import type { HighlightedRegionsStats } from '~/types/address-context';
import type { AddressData } from '~~/core/entities/Addresses';

import { useHighlightedRegionsMultiCity } from './useHighlightedRegions';

/**
 * Interface para regiões destacadas
 */
export interface UseHighlightedRegionsReturn {
	getHighlightedRegionsForCity: (state: string, city: string) => AddressData[];
	getHighlightedRegionsForMacroregion: (
		state: string,
		macroregion: string
	) => AddressData[];
	getHighlightedRegions: (
		state: string,
		city?: string,
		macroregion?: string,
		excludeRegions?: string[]
	) => AddressData[];
	getHighlightedRegionsForState: (state: string) => AddressData[];
	addHighlightedRegionsConfiguration: (
		state: string,
		location: string,
		regionNames: string[]
	) => void;
	getHighlightedRegionsStats: () => HighlightedRegionsStats;
}

/**
 * Wrapper que retorna a versão multi-cidade
 */
export function useHighlightedRegions(): UseHighlightedRegionsReturn {
	return useHighlightedRegionsMultiCity();
}
